import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {DeviceTypeService} from '../../device-type/device-type.service';
import {PackageServiceService} from '../../package/service/package-service.service';
import {ToastrService} from 'ngx-toastr';
import {FilterService} from '../service/filter.service';
import {first} from 'rxjs/operators';

@Component({
  selector: 'app-filter-form',
  templateUrl: './filter-form.component.html',
  styleUrls: ['./filter-form.component.css']
})
export class FilterFormComponent implements OnInit {
  filterId: any;
  campaignIdParam: any;
  filterValueMap = new Map();
  isEdit = false;
  filterDetailForm: FormGroup;
  categoryList: any = [];
  filterClassList: any = [];
  loading: boolean;
  submitted: boolean;
  constructor(private _formBuilder: FormBuilder,
              private _router: Router,
              private filterService: FilterService,
              private toastr: ToastrService,
              private _route: ActivatedRoute) {

    // this.route.fragment.subscribe(fragment => { this.filterId = fragment; });
      this._route.params.subscribe(routeParams => {this.filterId = routeParams.filterIdParam; });
      this._route.params.subscribe(routeParams => {this.campaignIdParam = routeParams.campaignIdParam; });

      console.log(this.filterId);
      console.log(this.campaignIdParam);
    if (this.filterId) {
      this.isEdit = true;
      this.getFilterDetails(this.filterId, this.campaignIdParam);
    }

    this.filterDetailForm = this._formBuilder.group({
      id: [''],
      name: ['', Validators.required],
      category: ['', Validators.required],
      filterClass: ['', Validators.required],
      enabled: ['', Validators.required],
      campaignId : ['', Validators.required],
      config: [{}, Validators.required]
    });
  }
  ngOnInit() {
    this.getCategories();
    this.getFilterClasses();
  }

  getCategories() {
    this.filterService.getAllCategories()
        .subscribe(data => {
          const response: any = data.json();
          this.categoryList = response;
          console.log(this.categoryList);
          this.loading = false;
        }, (error) => {
          this.loading = false;
        });
  }

  getFilterDetails(filterId, campaignId) {
    this.filterService.getFilterById(filterId)
        .subscribe(data => {
          const response: any = data.json();
          this.filterDetailForm.controls['name'].setValue( response.name);
          this.filterDetailForm.controls['category'].setValue( response.category);
          this.filterDetailForm.controls['filterClass'].setValue( response.filterClass);
          if (campaignId !== undefined) {
              this.filterDetailForm.controls['campaignId'].setValue(campaignId);
          }
          this.filterDetailForm.controls['config'].setValue( response.config);
          this.filterDetailForm.controls['enabled'].setValue( response.enabled);
          this.filterDetailForm.controls['id'].setValue(this.filterId);
          this.filterValueMap = this.filterDetailForm.controls['config'].value;
          console.log(this.filterDetailForm.value);
          this.loading = false;
        }, (error) => {
          this.loading = false;
        });
  }

  getFilterClasses() {
      this.filterClassList = [
        { id: 'com.elasticcare.workflow.filter.impl.ButterworthSensorDataFilter', name : 'ButterworthSensorDataFilter'}
        ];
  }

  saveFilter(filter) {
    console.log(filter);
    this.filterService.updateFilters(filter.value)
        .pipe(first())
        .subscribe(data => {
          if (data.status === 200) {
            this.toastr.success('', 'Filter Updated successfully');
            this._router.navigate(['/elasticcare/filter']);
            this.loading = false;
          } else {
            this.toastr.error('', 'Please try again');
          }
        }, (error) => {
          this.toastr.error('', 'Please try again');
          this.loading = false;
        });
  }

  onChange(filterKey, index, eventActualValue) {
    let tempCong = [];
    tempCong = this.filterValueMap[filterKey];
    console.log(tempCong);
    tempCong[index] = Number(eventActualValue);
    console.log(tempCong);
    this.filterValueMap[filterKey] = tempCong;
    console.log(this.filterValueMap);
/*    console.log(filterKey);
    console.log(index);
    console.log(eventActualValue);*/
  }
}
